export const getPositionIndex = (intervals, position) => {
    let left = 0;
    let right = intervals.length - 1;

    while (left <= right) {
        const mid = Math.floor((left + right) / 2);

        /**
         * `undefined` conditions covers edge cases, we know that `position` represents a middle of an annotation.
         * In case if the center hits the position change point, then we consider that the annotation refers to the
         * previous position (since the event started there).
         *  Example:
         *      const intervals = [[0, 10], [10, 25], [26, 30]];
         *      const annotation = {start: 0, end: 20}; // as we can see the middle equals 10
         *      const index = getPositionIndex((annotation.start + annotation.end) / 2); // 0
         */
        if (
            (position >= intervals[mid][0] && position < intervals[mid][1]) ||
            (position === intervals[mid][0] && intervals[mid - 1] === undefined) ||
            (position === intervals[mid][0] && intervals[mid + 1] === undefined)
        ) {
            return mid;
        } else if (position <= intervals[mid][0]) {
            right = mid - 1;
        } else {
            left = mid + 1;
        }
    }
};

export const getObjectValuesSum = (object) =>
    Object.values(object).reduce((acc, curr) => acc + curr, 0);
